export const styles = {
  wrapper: {
    textAlign: 'center',
    flexDirection: 'column',
  },
  imageContainer: {
    position: 'relative',
    maxWidth: '784px',
    m: 'auto',
  },
  buttonsWrapper: {
    width: 'fit-content',
    mx: [0, 'auto', 0, 0, 0, 0],
  },
  buttonContainer: {
    backgroundColor: '#36BFFA',
    py: '13px',
    px: '16px',
    display: 'flex',
    gap: '8px',
    width: 'fit-content',
    borderRadius: '8px',
    textDecoration: 'none',
    transition: 'all 250ms ease',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#0086C9',
    },
  },
  button: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '30px',
    color: '#fff',
    m: 0,
  },
  videoButtonContainer: {
    border: '1px solid #F9FAFB',
    boxShadow: '0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814',
    p: '16px',
    borderRadius: '16px',
    display: 'flex',
    gap: '20px',
    mx: 'auto',
    width: 'fit-content',
    mt: '60px',
    backgroundColor: '#fff',
    flexDirection: ['row', 'column', 'row', 'row', 'row'],
  },
  videoButtonTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    py: '12px',
    width: '310px',
  },
  videoButtonText: {
    m: 0,
    fontSize: '20px',
    lineHeight: '30px',
    fontWeight: 600,
    color: '#101828',
    textAlign: ['left', 'center', 'left', 'left', 'left', 'left'],
  },
  topButtonsContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    gap: '32px',
  },
  modal: {
    width: ['100%', '75%'],
    maxWidth: 'none',
    bg: '#000',
    px: 0,
    pb: 0,
    pt: ['56%', '42.15%'],
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    height: '100%',
  },
  imageWrapper: {
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.05)',
    },
    transition: 'all ease 250ms',
  },
};
